export default "__VITE_ASSET__CEUOFft3__"